import {Button} from 'alm-react-components';
import CarouselSection from '../../common/CarouselSection';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {APPROUTES, constants} from '../../../assets/constants/constants';
import { LibraryFilteration } from '../../../lib/utils';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../context/AppProvider';

const BookSection = ({
  books,
  addBookMark,
  deleteBookMark,
  catalogId,
  tagsData
}: {
  books: any;
  addBookMark: any;
  deleteBookMark: any;
  catalogId: any;
  tagsData:any
}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [filteredVideos,setFilteredVideos]=useState<any[]>([]);
  const {state} = useContext(AppContext);

  useEffect(() => {
    const data = LibraryFilteration(tagsData, books)
    setFilteredVideos(data);
  }, [tagsData, books])


  if (!filteredVideos || filteredVideos.length === 0) {
    return null;
  }

  return (
    <div className="mt-14 mb-14 xl:px-32 lg:px-8 md:px-8 px-5">
      <div className="flex flex-wrap justify-between md:flex-nowrap">
        <h2 className="text-3xl font-barlowLight pl-2 max-md:mb-4">
        <span dangerouslySetInnerHTML={{ __html: (t('Library.books')) }} /></h2>
        {!state?.keyword&&(
          <Button
            variant="outline"
            onClick={() => navigate(`/books/${catalogId?.id}`)}
            className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard border-0"
          >
            <span dangerouslySetInnerHTML={{ __html: (t('Common.seeAll')) }} />
          </Button>)}
          
      </div>
      <CarouselSection
        data={filteredVideos}
        addBookMark={addBookMark}
        deleteBookMark={deleteBookMark}
        type={constants.BOOKS}
        id={catalogId?.id}
        from={APPROUTES.library}
      />
    </div>
  );
};

export default BookSection;
